import { Navigate, Route, Routes } from 'react-router-dom'

import { OnboardingFormPage } from '../pages/FormPage/OnboardForm.Page'

/* ---------------------------------------------
   PUBLIC ROUTER
--------------------------------------------- */
export const HomeRouter = () => {

  return (
    <Routes>

      {/* Home Route */}
      <Route
        path='/'
        element={<OnboardingFormPage />}
      />

      {/* Optional support for old URL */}
      <Route
        path='/onboarding'
        element={<Navigate to='/' replace />}
      />

      {/* Fallback */}
      <Route
        path='*'
        element={<Navigate to='/' replace />}
      />

    </Routes>
  )
}